window.performance.mark('start_quick_fetch_script');
(function () {
  // Do not change this name! This is used by the Cloudflare worker as the key for the userInfo request.
  const API_VERIFY = 'api-verify';
  const ERROR_PREFIX = '[quick-fetch] Early request not found';
  let earlyRequests = {};
  let earlyRequestsHistory = [];

  // Timing utility for history tracking
  const hasNavigationStart = window.performance && window.performance.timing && window.performance.timing.navigationStart;
  const hasPerfNow = window.performance && window.performance.now;
  const pageStartTimestamp = hasNavigationStart ? window.performance.timing.navigationStart : new Date().valueOf();
  const perfNow = hasPerfNow ? window.performance.now.bind(window.performance) : () => {
    return new Date().valueOf() - pageStartTimestamp;
  };
  function getCookie(cookies) {
    var _getCookieByName;
    return (_getCookieByName = getCookieByName('csrf.app', cookies)) !== null && _getCookieByName !== void 0 ? _getCookieByName : null;
  }

  // TODO: Duplicated in chirp-fetch
  function getCookieByName(name, cookie) {
    const matches = cookie.match(`(?:^|;\\s*)${name}=(.*?)(?:;|$)`);
    if (!matches) {
      return undefined;
    }
    return decodeURIComponent(matches[1]);
  }
  function hasEarlyRequests() {
    return Object.keys(earlyRequests).filter(key => key !== API_VERIFY).length > 0;
  }
  function safeHasOwnProperty(object, key) {
    return object && Object.prototype.hasOwnProperty.call(object, key);
  }
  function getPortalId(optionalPath) {
    const portalExpression = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/;
    const portalIdResult = portalExpression.exec(optionalPath || document.location.pathname);
    const portalId = portalIdResult && portalIdResult[1];
    return portalId || undefined;
  }
  function formatVersion(version) {
    if (!version) {
      return 'unknown';
    }
    if (version === 'static') {
      return 'dev';
    }
    return version.replace('static-', '');
  }
  function getRequestNameForMark(name) {
    if (window.__workerEarlyRequests && window.__workerEarlyRequests[name]) {
      return `${name}-cloudflare`;
    }
    return name;
  }

  /**
   * Failure Injection is not supported in quick-fetch, we should skip quick-fetch so the call fails and utilizes hub-http which does support failure-injection
   */
  function shouldSkipEarlyRequestDueToFailureInjection() {
    try {
      return !!localStorage.getItem('HTTP_FAILURE_INJECTION');
    } catch (__err) {
      return false;
    }
  }
  function getRequestStateByName(name) {
    if (safeHasOwnProperty(earlyRequests, name)) {
      return earlyRequests[name];
    }
    return null;
  }
  function removeEarlyRequest(name) {
    if (safeHasOwnProperty(earlyRequests, name)) {
      delete earlyRequests[name];
    }
    if (safeHasOwnProperty(window.__workerEarlyRequests, name)) {
      delete window.__workerEarlyRequests[name];
    }
  }
  function clearAllRequests() {
    earlyRequests = {};
  }
  function requestSuccess(name, response, fromWorker = false) {
    const markName = getRequestNameForMark(name);
    const startMark = `mark_${markName}_request`;
    const endMark = `mark_${markName}_success`;

    // Prevent double marking. Measure will throw if both marks are not defined.
    if (window.performance.getEntriesByName(startMark, 'mark').length && window.performance.getEntriesByName(endMark, 'mark').length && window.performance.getEntriesByName(`mark_${markName}_success`).length === 0) {
      window.performance.mark(`mark_${markName}_success`);
      window.performance.measure(`measure_${markName}_time`, startMark, endMark);
    }
    if (!safeHasOwnProperty(earlyRequests, name) || fromWorker && !safeHasOwnProperty(window.__workerEarlyRequests, name)) {
      console.error(ERROR_PREFIX, name, response);
      return;
    }
    earlyRequests[name].finished = true;
    earlyRequests[name].data = response;

    // Update history with success state - find the most recent pending entry with this name
    const historyEntry = earlyRequestsHistory.slice().reverse().find(entry => entry.name === name && entry.state === 'pending');
    if (historyEntry) {
      var _earlyRequests$name$r;
      historyEntry.finished = perfNow();
      historyEntry.state = 'succeeded';
      historyEntry.statusCode = ((_earlyRequests$name$r = earlyRequests[name].request) === null || _earlyRequests$name$r === void 0 ? void 0 : _earlyRequests$name$r.status) || 200;
    }
    earlyRequests[name].whenFinishedCallbacks.forEach(cb => {
      cb(response);
    });
  }
  function requestError(name, statusCode, xhr, fromWorker = false) {
    if (!safeHasOwnProperty(earlyRequests, name) || fromWorker && !safeHasOwnProperty(window.__workerEarlyRequests, name)) {
      console.error(ERROR_PREFIX, name, statusCode, xhr);
      return;
    }
    earlyRequests[name].error = true;
    earlyRequests[name].errorStatus = statusCode;

    // Update history with error state - find the most recent pending entry with this name
    const historyEntry = earlyRequestsHistory.slice().reverse().find(entry => entry.name === name && entry.state === 'pending');
    if (historyEntry) {
      historyEntry.finished = perfNow();
      historyEntry.state = statusCode === 'timeout' ? 'timedOut' : 'failed';
      historyEntry.statusCode = xhr.status || 0;
    }
    earlyRequests[name].onErrorCallbacks.forEach(cb => {
      cb(xhr, statusCode);
    });
  }
  function makeEarlyRequestObject(request, ajaxOptions) {
    return {
      finished: false,
      error: false,
      errorStatus: '',
      whenFinishedCallbacks: ajaxOptions.whenFinished ? [ajaxOptions.whenFinished] : [],
      onErrorCallbacks: ajaxOptions.onError ? [ajaxOptions.onError] : [],
      whenFinished(cb) {
        if (this.finished) {
          cb(this.data);
        } else {
          this.whenFinishedCallbacks.push(cb);
        }
      },
      onError(cb) {
        if (this.error) {
          cb(this.request, this.errorStatus);
        } else {
          this.onErrorCallbacks.push(cb);
        }
      },
      request
    };
  }
  function promiseToWrappedXhr(promise, ajaxOptions, name) {
    const emptyRequest = new XMLHttpRequest();
    const earlyReqObject = makeEarlyRequestObject(emptyRequest, ajaxOptions);
    promise.then(({
      responseBody
    }) => {
      requestSuccess(name, responseBody, true);
    }).catch(error => {
      requestError(name, error.message || 'Unknown error', earlyReqObject.request, true);
    });
    return earlyReqObject;
  }
  function makeEarlyRequest(name, ajaxOptions) {
    const markName = getRequestNameForMark(name);
    if (shouldSkipEarlyRequestDueToFailureInjection()) {
      return;
    }
    if (window.__workerEarlyRequests && window.__workerEarlyRequests[name]) {
      window.performance.mark(`mark_${markName}_request`);

      // Record worker request to history
      earlyRequestsHistory.push({
        name,
        url: ajaxOptions.url,
        started: perfNow(),
        state: 'pending',
        statusCode: undefined,
        fromWorker: true
      });
      earlyRequests[name] = promiseToWrappedXhr(window.__workerEarlyRequests[name].promise, ajaxOptions, name);
      return;
    }
    if (safeHasOwnProperty(earlyRequests, name)) {
      return;
    }
    window.performance.mark(`mark_${markName}_request`);
    const request = new XMLHttpRequest();
    const url = new URL(ajaxOptions.url);
    const params = new URLSearchParams(url.search);
    const {
      _currentProject,
      _currentProjectVersion
    } = window.quickFetch;

    // Ensure static app info
    params.append('hs_static_app', _currentProject);
    params.append('hs_static_app_version', formatVersion(_currentProjectVersion));

    // Ensure portalId
    if (!ajaxOptions.noPortalId && !params.has('portalId')) {
      const portalId = getPortalId();
      if (portalId) {
        params.append('portalId', portalId);
      }
    }

    // Add hs_selenium cookie as query param if not already present
    if (!params.has('hs_selenium_test')) {
      const hsSeleniumCookie = getCookieByName('hs_selenium', window.document.cookie);
      if (hsSeleniumCookie) {
        params.append('hs_selenium_test', hsSeleniumCookie);
      }
    }

    // Add client timeout
    if (ajaxOptions.timeout && !params.has('clienttimeout')) {
      params.append('clienttimeout', `${ajaxOptions.timeout}`);
    }

    // Build the new URL with all the updated params
    const requestUrl = `${url.origin}${url.pathname}?${params.toString()}`;
    request.open(ajaxOptions.type ? ajaxOptions.type : 'GET', requestUrl, true);
    request.withCredentials = Object.prototype.hasOwnProperty.call(ajaxOptions, 'withCredentials') ? !!ajaxOptions.withCredentials : !ajaxOptions.noAuth;
    if (ajaxOptions.timeout != null) {
      request.timeout = ajaxOptions.timeout;
    }
    request.addEventListener('load', () => {
      let resp;
      if (200 <= request.status && request.status < 400) {
        resp = request.responseText;
        if (ajaxOptions.dataType === 'json') {
          try {
            resp = JSON.parse(resp);
          } catch (e) {
            requestError(name, 'Parsing error. Response is not valid JSON', request);
            return;
          }
        }
        requestSuccess(name, resp);
        return;
      }
      requestError(name, `Network request failed. Status: ${request.status}`, request);
    });
    request.addEventListener('error', () => {
      requestError(name, 'Network request failed', request);
    });
    request.addEventListener('timeout', () => {
      requestError(name, 'timeout', request);
    });
    const csrfCookie = getCookie(window.document.cookie);
    const shouldAddCsrf = csrfCookie !== null && !ajaxOptions.noAuth && !ajaxOptions.url.includes('/login-verify/hub-user-info');
    if (shouldAddCsrf) {
      request.setRequestHeader('X-HubSpot-CSRF-hubspotapi', csrfCookie);
    } else if (!csrfCookie && !ajaxOptions.noAuth) {
      console.error('No CSRF Cookie found.');
    }
    request.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
    if (!ajaxOptions.noAuth) {
      try {
        const hsLocale = localStorage.getItem('hs_locale');
        if (hsLocale) {
          request.setRequestHeader('X-HS-Locale', hsLocale);
        }
      } catch (e) {
        // noop
      }
    }
    if (ajaxOptions.extraHeaders && ajaxOptions.extraHeaders.length) {
      ajaxOptions.extraHeaders.forEach(headerObj => {
        request.setRequestHeader(headerObj.header, headerObj.value);
      });
    }
    if (ajaxOptions.contentType) {
      request.setRequestHeader('Content-type', ajaxOptions.contentType);
    }

    // Record to history when request starts
    earlyRequestsHistory.push({
      name,
      url: requestUrl,
      started: perfNow(),
      state: 'pending',
      statusCode: undefined,
      fromWorker: false
    });
    earlyRequests[name] = makeEarlyRequestObject(request, ajaxOptions);
    switch (ajaxOptions.type) {
      case 'GET':
      case undefined:
        {
          request.send();
          break;
        }
      case 'PUT':
      case 'PATCH':
      case 'POST':
        {
          if (!ajaxOptions.contentType) {
            request.setRequestHeader('Content-type', 'application/json');
          }
          request.send(ajaxOptions.data);
          break;
        }
      default:
        {
          console.error(`Unsupported quick-fetch method "${ajaxOptions.type}", skipping quick-fetch for \${ajaxOptions.url}`);
          return;
        }
    }
  }
  function getApiBaseUrl(apiPassthrough, hostnameOverride) {
    let subdomain;
    const hostname = hostnameOverride || window.location.hostname;
    const hubletRe = /^(api|local|app|mcp)-(.*)\.hubspot(documents)?(qa)?\.com/;
    const isHublet = hubletRe.test(hostname);
    const isQaRe = /\.(hubspot(documents)?qa\.com|wthubspot\.(com|de|es|fr|jp))/;
    const isQA = isQaRe.test(hostname);

    // Default to apiPassthrough=true if unset, respect the setting if explicitly disabled
    if (typeof apiPassthrough === 'undefined') {
      apiPassthrough = true;
    }
    if (!isHublet) {
      subdomain = apiPassthrough ? 'app' : 'api';
    } else {
      const regexResults = hubletRe.exec(hostname);
      const hublet = regexResults[2];
      subdomain = apiPassthrough ? `app-${hublet}` : `api-${hublet}`;
    }
    return apiPassthrough ? `https://${subdomain}.hubspot${isQA ? 'qa' : ''}.com/api` : `https://${subdomain}.hubspot${isQA ? 'qa' : ''}.com`;
  }
  function getApiUrl(endpoint, apiPassthrough, hostnameOverride, baseUrlOverride) {
    let baseUrl = baseUrlOverride !== undefined ? baseUrlOverride : getApiBaseUrl(apiPassthrough, hostnameOverride);
    try {
      const localOverrides = JSON.parse(localStorage.getItem('LOCAL_API_OVERRIDES'));
      for (let index = 0; index < localOverrides.length; index++) {
        if (endpoint.includes(localOverrides[index])) {
          baseUrl = baseUrl.replace(/https:\/\/(app|api)/, 'https://local').replace('/api', '');
        }
      }
    } catch (e) {
      // do nothing
    }
    return baseUrl + endpoint;
  }

  // Check if running in an iframe and quick fetch is available in top-level context
  function isNestedContext() {
    try {
      return window.top !== window && window.top.quickFetch && typeof window.top.quickFetch.getRequestStateByName === 'function';
    } catch (e) {
      // Required for cross-domain setting
      return false;
    }
  }
  function makeLoginVerifyRequest(additionalOptions = {}) {
    if (isNestedContext()) {
      const cached = window.top.quickFetch.getRequestStateByName(API_VERIFY);
      if (cached) {
        earlyRequests[API_VERIFY] = Object.assign({}, cached, {
          fromParentContext: true
        });
        return;
      }
    }
    const url = getApiUrl('/login-verify/hub-user-info?early=true');
    const requestOptions = Object.assign({
      url,
      dataType: 'json',
      timeout: 3000
    }, additionalOptions);
    makeEarlyRequest(API_VERIFY, requestOptions);
  }
  function getLoginVerifyRequest() {
    return getRequestStateByName(API_VERIFY);
  }
  function afterAuth(func) {
    const verifyRequest = getLoginVerifyRequest();
    if (verifyRequest) {
      verifyRequest.whenFinished(func);
    }
  }
  function getAllEarlyRequestStats() {
    return earlyRequestsHistory;
  }
  function clearEarlyRequestHistory() {
    earlyRequestsHistory = [];
  }
  window.quickFetch = {
    afterAuth,
    clearAllRequests,
    clearEarlyRequestHistory,
    getApiUrl,
    getPortalId,
    getRequestStateByName,
    getAllEarlyRequestStats,
    makeEarlyRequest,
    makeLoginVerifyRequest,
    getLoginVerifyRequest,
    removeEarlyRequest,
    getCookie,
    hasEarlyRequests
    // these are guaranteed to exist when the page inits by construction of the QuickFetchScript
  };

  // Performance mark to keep track of when the script actually starts and stops
  // (in comparison to when the API call actually starts)
  window.performance.mark('end_quick_fetch_script');
  window.performance.measure('measure_quick_fetch_script', 'start_quick_fetch_script', 'end_quick_fetch_script');
})();
export {};
/*** EXPORTS FROM exports-loader ***/
export default quickFetch;
